import { z } from 'zod';
import { SyncableEntitySchema } from './entity';

export const SubjectCodeSchema = z.enum(['COMBINED_MATHS', 'PHYSICS', 'CHEMISTRY', 'BIOLOGY', 'ICT', 'CUSTOM']);
export type SubjectCode = z.infer<typeof SubjectCodeSchema>;

export const SubjectSchema = SyncableEntitySchema.extend({
  code: z.string().min(1),
  name: z.string().min(1),
  colorToken: z.enum(['gold', 'indigo', 'mint', 'cyan', 'rose']),
  sortOrder: z.number().int().default(0),
  targetHours: z.number().positive().default(300),
  isArchived: z.boolean().default(false),
});

export type Subject = z.infer<typeof SubjectSchema>;
